export default {
  infoToggle: "Show help and theme examples",
  maxWarning:
    "You have reached the maximum of {max} characters for the theme. Remember that short keywords are enough.",
};
